export default function Portal() {
  return <div id='luruPortal'></div>
}
